export const FilterType = {
  DATE: 2,
  DATE_RANGE: 4,
  SINGLE_DROPDOWN: 8,
  MULTI_DROPDOWN: 16
}

export const ORDER_FILTER_FUNDS =[
  { label: 'common_all', value: 'all' },
  { label: 'common_funds', value: 'funds' },

]

export const ORDER_FILTER_STATUS = [
  { label: 'common_all', value: 'all' },
  // -------------- common ---------------------
  { label: 'order_status_psb', value: 'psb' },
  { label: 'order_status_fll', value: 'fll,alf,fex,spf,cpd' },
  { label: 'order_status_can', value: 'can' },
  { label: 'order_status_rej', value: 'rej' },
  { label: 'order_status_pxp', value: 'pex,spp,bix2,pxp' },
  { label: 'order_status_exp', value: 'exp' },
  { label: 'order_status_iav', value: 'iav' },
  { label: 'order_status_bix', value: 'bix' },
  { label: 'order_status_stb', value: 'stb' },
  { label: 'order_status_ack', value: 'ack' },
  { label: 'order_status_bpm', value: 'bpm' },
  { label: 'order_status_mpa', value: 'mpa' },
  { label: 'order_status_mxs', value: 'mxs' },
  { label: 'order_status_sor', value: 'sor' },
  // -------------- common ---------------------
  // { label: 'order_status_scb_soi', value: 'soi' },
  // { label: 'order_status_scb_iav', value: 'iav' },
  // { label: 'order_status_scb_pap', value: 'pap' },
  // { label: 'order_status_scb_psb', value: 'psb' },
  // { label: 'order_status_scb_stb', value: 'stb' },
  // { label: 'order_status_scb_bix', value: 'bix' },
  // { label: 'order_status_scb_bpm', value: 'bpm' },
  // { label: 'order_status_scb_bms', value: 'bms' },
  // { label: 'order_status_scb_bss', value: 'bss' },
  // { label: 'order_status_scb_rej', value: 'rej' },
  // { label: 'order_status_scb_can', value: 'can' },
  // { label: 'order_status_scb_kll', value: 'kll' },
  // { label: 'order_status_scb_fll', value: 'fll' },
  // { label: 'order_status_scb_cmo', value: 'cmo' },
  // { label: 'order_status_scb_mpa', value: 'mpa' },
  // { label: 'order_status_scb_mps', value: 'mps' },
  // { label: 'order_status_scb_msd', value: 'msd' },
  // { label: 'order_status_scb_cpd', value: 'cpd' },
  // { label: 'order_status_scb_exp', value: 'epx' },
  // { label: 'order_status_scb_pxp', value: 'pxp' },
  // { label: 'order_status_scb_pex', value: 'pex' },

]

export const TRANSACTION_TYPE = [
  { label: 'common_all', value: 'ALL' },
  { label: 'transType_SCAS', value: 'SCAS' },
  { label: 'transType_SCCB', value: 'SCCB' },
  { label: 'transType_CCPCD', value: 'CCPCD' },
  { label: 'transType_CCPCW', value: 'CCPCW' },
  { label: 'transType_SCAC', value: 'SCAC' },
  { label: 'transType_SCAXW', value: 'SCAXW' },
  { label: 'transType_SCAXD', value: 'SCAXD' },
  { label: 'transType_SCATW', value: 'SCATW' },
  { label: 'transType_SCATD', value: 'SCATD' },
  { label: 'transType_CCIPOS', value: 'CCIPOS' },
  { label: 'transType_SCCS', value: 'SCCS' },
  { label: 'transType_SCPSD', value: 'SCPSD' },
  { label: 'transType_SCPSW', value: 'SCPSW' },
  { label: 'transType_SCAVD', value: 'SCAVD' },
  { label: 'transType_SCAVW', value: 'SCAVW' },
  { label: 'transType_SCAIW', value: 'SCAIW' },
  { label: 'transType_CCPCEW', value: 'CCPCEW'}, 
  { label: 'transType_CCPCED', value: 'CCPCED'}
]

export const ACCOUNT_TYPE = [
  { label: 'common_all', value: 'A' },
  { label: 'common_cash', value: 'C' },
  { label: 'common_margin', value: 'M' }
]

export const STATEMENT_TYPE = [
  { label: 'common_all', value: 'A' },
  { label: 'Daily', value: 'D' },
  { label: 'Monthly', value: 'M' }
]

export const PERIOD = [
  // { label: 'common_all', value: 'A' },
  { label: 'five_recent', value: '5C' },
  { label: 'three_days', value: '3D' },
  { label: 'onw_weeks', value: '1W' },
  { label: 'two_weeks', value: '2W' },
  { label: 'one_months', value: '1M' },
  { label: 'two_months', value: '2M' },
  { label: 'three_months', value: '3M' },
  { label: 'six_months', value: '6M' },
  { label: 'twelve_months', value: '12M' },
  { label: 'three_years', value: '3Y' }
]

export const CURRENCY =[
  {label:'All',value:''},
  {label:'HKD',value:'HKD'},
  {label:'CNY',value:'CNY'},
  {label:'USD',value:'USD'}
]

export const ORDER_FILTER_STATUS_GROUP = [
  { label: 'market_all', value: 'all' },
  { label: 'order_status_outstanding', value: 'Outstanding' },
  { label: 'order_status_cpd', value: 'Completed' },
  { label: 'order_status_cdc', value: 'Cancelled' },
]

export const ORDER_FILTER_STATUS_GROUP_MOBILE = [
  { label: 'all_status', value: 'all' },
  { label: 'order_status_outstanding', value: 'Outstanding' },
  { label: 'order_status_cpd', value: 'Completed' },
  { label: 'order_status_cdc', value: 'Cancelled' },
]

export const WATCHLIST_FILTER_TYPE ={
  TITLE:"flag_lists_100639_6081",
  All:"flag_lists_1_6093",
  HK:"flag_lists_1_6094",
  US:"flag_lists_1_6095",
  StockConnect:"flag_lists_1_6096",
  FUND:'flag_lists_100754_7361'
}

export const ACCOUNT_TYPE_MOBILE = [
  { label: 'mobile_all_account-type', value: 'A' },
  { label: 'common_cash', value: 'C' },
  { label: 'common_margin', value: 'M' }
]

export const STATEMENT_TYPE_MOBILE = [
  { label: 'mobile_all_statement-type', value: 'A' },
  { label: 'Daily', value: 'D' },
  { label: 'Monthly', value: 'M' }
]